import React, { useCallback, useEffect, useState } from 'react'
import { AiOutlineFilePdf } from 'react-icons/ai'
import { HeaderPage } from '../../../components/HeaderPage'
import { RelatoryMenu } from '../../../components/Relatory/RealatoryMenu'
import { RelatoryFilter } from '../../../components/Relatory/RelatoryFilter'
import useApi from '../../../hooks/useApi'
import { TextInput } from '../../../Korbantech/components/Inputs/TextInput'
import { Label } from '../../../Korbantech/components/Label'
import { AdminLayout } from '../../../layout/AdminLayout'
import fileDownload from "js-file-download";

export const ByRegion = () => {

    const api = useApi()

    const [data, setData] = useState<{
        avarege: number
        diagnosis: number
        oscs: number
        region: string
    }[]>();

    const loadDashboard = useCallback(async () => {
        await api.get("admin/metrics/region").then(res => {
            setData(res.data)
        }).catch(console.log)
    }, [api])

    useEffect(() => {
        loadDashboard()
    }, [loadDashboard])

    const loadPDF = useCallback(() => {
        api.get("admin/metrics/pdf-region").then(res => {
            fileDownload( res.data, 'invoices.csv' )
        }).catch(console.log)
    }, [api])

    return (
        <AdminLayout>
            <HeaderPage name='Relatorios por região' button={<div className='flex items-end gap-x-3' onClick={loadPDF}>
                <button className='h-9 bg-white border-2 flex items-center border-gray-300 py-1 px-3'>
                   <AiOutlineFilePdf className='mr-1'/> Exportar relatório
                </button>
                    <Label>
                    Buscar
                    <div className='flex'>
                    <TextInput />
                    </div>
                </Label>
                </div> } />
            <RelatoryMenu  />
            <RelatoryFilter cause score />
            <div className='grid grid-cols-12 font-semibold text-gray-700 py-3 pr-3'>
                <div className='col-span-5'>Região</div>
                <div className='text-center col-span-2'>OSCs</div>
                <div className='text-center col-span-2'>Testes</div>
                <div className='text-center col-span-'>0 - 7</div>
                <div className='text-center col-span-'>8 a 10</div>
                <div className='text-center col-span-'>Nota média</div>
            </div>
            {data?.map(item => (
                <div key={item.region} className='grid grid-cols-12 bg-white p-4'>
                    <div className='col-span-5'>{item.region}</div>
                    <div className='text-center col-span-2'>{item.oscs}</div>
                    <div className='text-center col-span-2'>{item.diagnosis}</div>
                    <div className='text-center text-blue-500 col-span-'>0 {"(0%)"}</div>
                    <div className='text-center text-green-500 col-span-'>0 {"(0%)"}</div>
                    <div className='text-center col-span-'>{item.avarege ? (item.avarege *1) : 0}</div>
                </div>
            ))}
        </AdminLayout>
    )
}
